import { useState } from 'react';
import { LockClosedIcon } from '@radix-ui/react-icons';
import { Button, Dialog, TextField } from '@radix-ui/themes';

export const DomainPasswordModal: React.FC<{ open: boolean; onPasswordCorrect: () => void }> = ({
  open,
  onPasswordCorrect,
}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (password.toLowerCase() === 'tennis stalker') {
      setError('');
      onPasswordCorrect();
    } else {
      setError('Password non corretta');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Dialog.Root open={open}>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-center'>
          <Dialog.Title>QUESTO E' UN AMBIENTE DI TEST</Dialog.Title>
        </div>
        <Dialog.Description className='hidden'>
          Inserisci la password per accedere al sito in questo ambiente
        </Dialog.Description>

        <div className='flex flex-col items-center justify-center gap-4'>
          <div className='flex items-center justify-center'>
            <LockClosedIcon height={'48'} width={'48'} className='text-neutral-neutral-9' />
          </div>

          <div className='text-neutral-neutral-11 text-center'>
            Se vuoi visitare TennisTalker, clicca qui:
            <a
              href={`https://www.tennistalker.it${window.location.pathname}`}
              className='!text-lime-11 !hover:text-lime-12 !underline'
              target='_blank'
              rel='noopener noreferrer'
            >
              www.tennistalker.it{window.location.pathname}
            </a>
          </div>

          <div className='text-neutral-neutral-11 text-center'>
            Questo ambiente di test richiede una password per l'accesso.
          </div>

          <div className='w-full'>
            <TextField.Root
              size='2'
              type='password'
              placeholder='Inserisci la password'
              value={password}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
            {error && <p className='text-red-9 mt-2 text-sm'>{error}</p>}
          </div>

          <Button className='w-full cursor-pointer' onClick={handleSubmit}>
            Accedi
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DomainPasswordModal;
